<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('drawer_title_fabric') || '面料工价维护'"
      direction="rtl"
      :size="1200"
      @close="$refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :is-copy="isCopy"
          :pdProcessDictCode="pdProcessDictCode"
          :pdProcessDictFabricCode="pdProcessDictFabricCode"
          @close="close()"
        />
        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.main.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    pdProcessDictCode: { type: String, default: '' },
    pdProcessDictFabricCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      if (!this.disabled) this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
